import deephowApiServerWrapper from "@/server/api-server";

export const getTextToSpeechByIds = (params) => deephowApiServerWrapper("get", `/v1/text-2-speech`, { params });

export const getTextTiSpeechHistoryById = (id) =>
  deephowApiServerWrapper("get", `/v1/workflows/${id}/text-2-speech-histories `);
